import { gql } from '@apollo/client';

export default gql`
  mutation confirmSpaceInvitation($token: String!) {
    confirmSpaceInvitation(input: { token: $token }) {
      success
    }
  }
`;
